"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5657],{

/***/ 36239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ monday_markup_language_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./client/services/monday-markup-language/pattern-data-service/base-pattern-data-service.js


var BasePatternDataService = /*#__PURE__*/ function() {
    "use strict";
    function BasePatternDataService() {
        (0,_class_call_check/* default */.Z)(this, BasePatternDataService);
    }
    (0,_create_class/* default */.Z)(BasePatternDataService, [
        {
            key: "locale",
            set: function set(val) {
                this.localeId = val;
            }
        },
        {
            key: "regex",
            value: function regex() {
                return "";
            }
        },
        {
            key: "isRecursive",
            value: function isRecursive() {
                return false;
            }
        },
        {
            key: "patternCharsCount",
            value: function patternCharsCount() {
                return 0;
            }
        },
        {
            key: "onMountHandler",
            value: function onMountHandler(containerElement) {}
        },
        {
            key: "onUmountHandler",
            value: function onUmountHandler(containerElement) {}
        },
        {
            key: "replacer",
            value: function replacer() {
                return null;
            }
        }
    ]);
    return BasePatternDataService;
}();


// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./client/services/monday-markup-language/pattern-data-service/color-pattern-data-service.js






var color_regex = ".+?";
// "This is an <monday-color blue>Example</monday-color> for a <monday-color pink>colorful title</monday-color>."
var INNER_REGEX_EXPRESSION = "(<monday-color (".concat(color_regex, ")>(.*?)</monday-color>)");
var REGEX_EXPRESSION = "(<monday-color .+?>".concat(color_regex, "</monday-color>)");
var ColorPatternDataService = /*#__PURE__*/ function(BasePatternDataService) {
    "use strict";
    (0,_inherits/* default */.Z)(ColorPatternDataService, BasePatternDataService);
    var _super = (0,_create_super/* default */.Z)(ColorPatternDataService);
    function ColorPatternDataService() {
        (0,_class_call_check/* default */.Z)(this, ColorPatternDataService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ColorPatternDataService, [
        {
            key: "regex",
            value: function regex() {
                return REGEX_EXPRESSION;
            }
        },
        {
            key: "isRecursive",
            value: function isRecursive() {
                return true;
            }
        },
        {
            key: "patternCharsCount",
            value: function patternCharsCount() {
                return 0;
            }
        },
        {
            // <monday-color blue>Example</monday-color>
            key: "replacer",
            value: function replacer(value) {
                var result = value.match(INNER_REGEX_EXPRESSION);
                var color = result[2];
                var text = result[3];
                return '<span class="colored" style="color: '.concat(colors/* default */.Z[color], '; font: inherit;">').concat(text, "</span>");
            }
        }
    ]);
    return ColorPatternDataService;
}(BasePatternDataService);


;// CONCATENATED MODULE: ./client/services/monday-markup-language/pattern-data-service/dot-pattern-data-service.js






// "This is an <monday-dot blue /> Example"
var dot_pattern_data_service_INNER_REGEX_EXPRESSION = "(<monday-dot (.+?) />)";
var dot_pattern_data_service_REGEX_EXPRESSION = "(<monday-dot .+? />)";
var DotPatternDataService = /*#__PURE__*/ function(BasePatternDataService) {
    "use strict";
    (0,_inherits/* default */.Z)(DotPatternDataService, BasePatternDataService);
    var _super = (0,_create_super/* default */.Z)(DotPatternDataService);
    function DotPatternDataService() {
        (0,_class_call_check/* default */.Z)(this, DotPatternDataService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(DotPatternDataService, [
        {
            key: "regex",
            value: function regex() {
                return dot_pattern_data_service_REGEX_EXPRESSION;
            }
        },
        {
            key: "isRecursive",
            value: function isRecursive() {
                return false;
            }
        },
        {
            key: "replacer",
            value: function replacer(value) {
                var result = value.match(dot_pattern_data_service_INNER_REGEX_EXPRESSION);
                var color = result[2];
                return '<span style="color: '.concat(colors/* default */.Z[color], '; font: inherit; font-size: 3.263rem;padding-left: 2px;">.</span>');
            }
        }
    ]);
    return DotPatternDataService;
}(BasePatternDataService);


// EXTERNAL MODULE: ./constants/localized-number-of-customers.js
var localized_number_of_customers = __webpack_require__(2522);
;// CONCATENATED MODULE: ./client/services/monday-markup-language/pattern-data-service/paying-companies-pattern-data-service.js






// "This is an <monday-paying-companies /> example"
var paying_companies_pattern_data_service_REGEX_EXPRESSION = "(<monday-paying-companies />)";
var PayingCompaniesPatternDataService = /*#__PURE__*/ function(BasePatternDataService) {
    "use strict";
    (0,_inherits/* default */.Z)(PayingCompaniesPatternDataService, BasePatternDataService);
    var _super = (0,_create_super/* default */.Z)(PayingCompaniesPatternDataService);
    function PayingCompaniesPatternDataService() {
        (0,_class_call_check/* default */.Z)(this, PayingCompaniesPatternDataService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(PayingCompaniesPatternDataService, [
        {
            key: "regex",
            value: function regex() {
                return paying_companies_pattern_data_service_REGEX_EXPRESSION;
            }
        },
        {
            key: "isRecursive",
            value: function isRecursive() {
                return false;
            }
        },
        {
            key: "replacer",
            value: function replacer(value) {
                return "".concat((0,localized_number_of_customers/* getLocalizedNumberOfPayingTeams */.i)(this.localeId));
            }
        }
    ]);
    return PayingCompaniesPatternDataService;
}(BasePatternDataService);


;// CONCATENATED MODULE: ./client/services/monday-markup-language/pattern-data-service/new-line-pattern-data-service.js





var new_line_pattern_data_service_REGEX_EXPRESSION = "(<monday-new-line />)";
var NewLinePatternDataService = /*#__PURE__*/ function(BasePatternDataService) {
    "use strict";
    (0,_inherits/* default */.Z)(NewLinePatternDataService, BasePatternDataService);
    var _super = (0,_create_super/* default */.Z)(NewLinePatternDataService);
    function NewLinePatternDataService() {
        (0,_class_call_check/* default */.Z)(this, NewLinePatternDataService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(NewLinePatternDataService, [
        {
            key: "regex",
            value: function regex() {
                return new_line_pattern_data_service_REGEX_EXPRESSION;
            }
        },
        {
            key: "isRecursive",
            value: function isRecursive() {
                return false;
            }
        },
        {
            key: "patternCharsCount",
            value: function patternCharsCount() {
                return 0;
            }
        },
        {
            key: "replacer",
            value: function replacer(value) {
                return "<br/>";
            }
        }
    ]);
    return NewLinePatternDataService;
}(BasePatternDataService);


;// CONCATENATED MODULE: ./client/services/monday-markup-language/pattern-data-service/bold-pattern-data-service.js





//example: <monday-bold>this is bold text</monday-bold>
var bold_pattern_data_service_REGEX_EXPRESSION = "(<monday-bold>.+</monday-bold>)";
var bold_pattern_data_service_INNER_REGEX_EXPRESSION = "(<monday-bold>(.+)</monday-bold>)";
var BoldPatternDataService = /*#__PURE__*/ function(BasePatternDataService) {
    "use strict";
    (0,_inherits/* default */.Z)(BoldPatternDataService, BasePatternDataService);
    var _super = (0,_create_super/* default */.Z)(BoldPatternDataService);
    function BoldPatternDataService() {
        (0,_class_call_check/* default */.Z)(this, BoldPatternDataService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BoldPatternDataService, [
        {
            key: "regex",
            value: function regex() {
                return bold_pattern_data_service_REGEX_EXPRESSION;
            }
        },
        {
            key: "isRecursive",
            value: function isRecursive() {
                return true;
            }
        },
        {
            key: "patternCharsCount",
            value: function patternCharsCount() {
                return 0;
            }
        },
        {
            key: "replacer",
            value: function replacer(value) {
                var result = value.match(bold_pattern_data_service_INNER_REGEX_EXPRESSION);
                var text = result[2];
                return "<b>".concat(text, "</b>");
            }
        }
    ]);
    return BoldPatternDataService;
}(BasePatternDataService);


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./utils/url.js
var url = __webpack_require__(8339);
;// CONCATENATED MODULE: ./client/services/monday-markup-language/pattern-data-service/url-param-data-service.js






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


var url_param_regex = ".+?";
var fallback_param_regex = ".+?";
// "Hi, <monday-url-param name friend>! This is an example of usage for the link /page?name=barak or /page."
var url_param_data_service_INNER_REGEX_EXPRESSION = "(<monday-url-param (".concat(url_param_regex, ") (").concat(fallback_param_regex, ") />)");
var url_param_data_service_REGEX_EXPRESSION = "(<monday-url-param .+? />)";
var UrlParamDataService = /*#__PURE__*/ function(BasePatternDataService) {
    "use strict";
    (0,_inherits/* default */.Z)(UrlParamDataService, BasePatternDataService);
    var _super = (0,_create_super/* default */.Z)(UrlParamDataService);
    function UrlParamDataService() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, UrlParamDataService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getParamValueFromUrl", function(paramName) {
            return (0,url.getUrlParamValueFromCurrentLocation)(paramName) || "";
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(UrlParamDataService, [
        {
            key: "regex",
            value: function regex() {
                return url_param_data_service_REGEX_EXPRESSION;
            }
        },
        {
            key: "isRecursive",
            value: function isRecursive() {
                return false;
            }
        },
        {
            key: "patternCharsCount",
            value: function patternCharsCount() {
                return 0;
            }
        },
        {
            key: "replacer",
            value: function replacer(value) {
                var result = value.match(url_param_data_service_INNER_REGEX_EXPRESSION);
                var paramName = result[2];
                var fallback = result[3];
                return "".concat(this.getParamValueFromUrl(paramName) || fallback);
            }
        }
    ]);
    return UrlParamDataService;
}(BasePatternDataService);


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/lodash/values.js
var values = __webpack_require__(52628);
var values_default = /*#__PURE__*/__webpack_require__.n(values);
;// CONCATENATED MODULE: ./client/services/monday-markup-language/pattern-data-service/font-size-pattern-data-service.js







var FONT_SIZES = {
    SM: "sm",
    MD: "md",
    LG: "lg"
};
var _obj;
var FONT_SIZE_MAPPING = (_obj = {}, (0,src_define_property/* default */.Z)(_obj, FONT_SIZES.SM, 1.8), (0,src_define_property/* default */.Z)(_obj, FONT_SIZES.MD, 2.7), (0,src_define_property/* default */.Z)(_obj, FONT_SIZES.LG, 3.6), _obj);
var FONT_SIZE_REGEX = values_default()(FONT_SIZES).join("|");
//example: <monday-font-size lg>large text</monday-font-size>
var font_size_pattern_data_service_REGEX_EXPRESSION = "(<monday-font-size .+?>.+</monday-font-size>)";
var font_size_pattern_data_service_INNER_REGEX_EXPRESSION = "(<monday-font-size (".concat(FONT_SIZE_REGEX, ")>(.+)</monday-font-size>)");
var FontSizePatternDataService = /*#__PURE__*/ function(BasePatternDataService) {
    "use strict";
    (0,_inherits/* default */.Z)(FontSizePatternDataService, BasePatternDataService);
    var _super = (0,_create_super/* default */.Z)(FontSizePatternDataService);
    function FontSizePatternDataService() {
        (0,_class_call_check/* default */.Z)(this, FontSizePatternDataService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(FontSizePatternDataService, [
        {
            key: "regex",
            value: function regex() {
                return font_size_pattern_data_service_REGEX_EXPRESSION;
            }
        },
        {
            key: "isRecursive",
            value: function isRecursive() {
                return false;
            }
        },
        {
            key: "patternCharsCount",
            value: function patternCharsCount() {
                return 0;
            }
        },
        {
            key: "replacer",
            value: function replacer(value) {
                var result = value.match(font_size_pattern_data_service_INNER_REGEX_EXPRESSION);
                var fontSizeStr = result[2];
                var fontSize = FONT_SIZE_MAPPING[fontSizeStr];
                var text = result[3];
                return '<span style="font-size: '.concat(fontSize, 'rem;" >').concat(text, "</span>");
            }
        }
    ]);
    return FontSizePatternDataService;
}(BasePatternDataService);


// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
;// CONCATENATED MODULE: ./client/services/monday-markup-language/pattern-data-service/hyperlink-pattern-data-service.js







var HYPER_LINK_REGEX = ".+?";
//example: <monday-hyperlink href="http://somewebsite.com">Click Here</monday-hyperlink>
var hyperlink_pattern_data_service_REGEX_EXPRESSION = "(<monday-hyperlink ".concat(HYPER_LINK_REGEX, ">.+</monday-hyperlink>)");
var hyperlink_pattern_data_service_INNER_REGEX_EXPRESSION = '(<monday-hyperlink href="('.concat(HYPER_LINK_REGEX, ')">(.+)</monday-hyperlink>)');
var HyperlinkPatternDataService = /*#__PURE__*/ function(BasePatternDataService) {
    "use strict";
    (0,_inherits/* default */.Z)(HyperlinkPatternDataService, BasePatternDataService);
    var _super = (0,_create_super/* default */.Z)(HyperlinkPatternDataService);
    function HyperlinkPatternDataService() {
        (0,_class_call_check/* default */.Z)(this, HyperlinkPatternDataService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(HyperlinkPatternDataService, [
        {
            key: "regex",
            value: function regex() {
                return hyperlink_pattern_data_service_REGEX_EXPRESSION;
            }
        },
        {
            key: "onMountHandler",
            value: function onMountHandler(containerElement) {
                containerElement === null || containerElement === void 0 ? void 0 : containerElement.addEventListener("click", HyperlinkPatternDataService.onClick);
            }
        },
        {
            key: "onUmountHandler",
            value: function onUmountHandler(containerElement) {
                containerElement === null || containerElement === void 0 ? void 0 : containerElement.removeEventListener("click", HyperlinkPatternDataService.onClick);
            }
        },
        {
            key: "replacer",
            value: function replacer(value) {
                var result = value.match(hyperlink_pattern_data_service_INNER_REGEX_EXPRESSION);
                var href = result[2];
                var text = result[3];
                return '<a href="'.concat(href, '" style="font: inherit;" data-monday-hyperlink>').concat(text, "</a>");
            }
        }
    ], [
        {
            key: "onClick",
            value: function onClick(e) {
                if (e.target.hasAttribute("data-monday-hyperlink")) {
                    (0,bigbrain_service.trackEvent)(bigbrain_event_types.MONDAY_HYPERLINK_CLICKED, {
                        info1: e.target.innerText,
                        info2: e.target.href
                    });
                }
            }
        }
    ]);
    return HyperlinkPatternDataService;
}(BasePatternDataService);


;// CONCATENATED MODULE: ./client/services/monday-markup-language/pattern-data-services.js








/* harmony default export */ var pattern_data_services = ([
    ColorPatternDataService,
    DotPatternDataService,
    PayingCompaniesPatternDataService,
    NewLinePatternDataService,
    UrlParamDataService,
    BoldPatternDataService,
    FontSizePatternDataService,
    HyperlinkPatternDataService
].map(function(patternDataService) {
    return new patternDataService();
}));

;// CONCATENATED MODULE: ./client/services/monday-markup-language/monday-markup-language-service.js

var buildRegexPattern = function() {
    return pattern_data_services.map(function(patternDataService) {
        return patternDataService.regex();
    }).join("|");
};
var getOnMountHandlers = function() {
    return pattern_data_services.map(function(patternDataService) {
        return patternDataService.onMountHandler;
    });
};
var getOnUnmountHandlers = function() {
    return pattern_data_services.map(function(patternDataService) {
        return patternDataService.onUmountHandler;
    });
};
var parseText = function(text, localeId) {
    try {
        var regexPatterns = buildRegexPattern();
        var regex = new RegExp(regexPatterns);
        var finalText = "";
        var result = "";
        while(result = text.match(regex)){
            pattern_data_services.forEach(function(patternDataService, index) {
                patternDataService.locale = localeId;
                var group = index + 1;
                var value = result[group];
                if (value) {
                    var markupTagPrefix = text.substring(0, result.index);
                    var currentValue = "".concat(finalText).concat(markupTagPrefix).concat(patternDataService.replacer(value));
                    finalText = patternDataService.isRecursive() ? parseText(currentValue, localeId) : currentValue;
                    var offset = Math.min(result.index + value.length + patternDataService.patternCharsCount(), text.length);
                    text = text.substring(offset, text.length);
                }
            });
        }
        return finalText + text;
    } catch (error) {
        console.error("Error in parseText:", error);
        return text;
    }
};

// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
;// CONCATENATED MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js









var MondayMarkupLanguageComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(MondayMarkupLanguageComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(MondayMarkupLanguageComponent);
    function MondayMarkupLanguageComponent(props) {
        (0,_class_call_check/* default */.Z)(this, MondayMarkupLanguageComponent);
        var _this;
        _this = _super.call(this, props);
        _this.ref = /*#__PURE__*/ react.createRef();
        return _this;
    }
    (0,_create_class/* default */.Z)(MondayMarkupLanguageComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                getOnMountHandlers().forEach(function(handler) {
                    handler(_this.ref.current);
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _this = this;
                getOnUnmountHandlers().forEach(function(handler) {
                    handler(_this.ref.current);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, CustomTag = _props.tagName, text = _props.text, className = _props.className, style = _props.style, localeId = _props.localeId;
                if (!text) return null;
                var parsedText = parseText(text, localeId);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTag, {
                    ref: this.ref,
                    className: classnames_default()("monday-markup-language-component", className),
                    dangerouslySetInnerHTML: {
                        __html: parsedText
                    },
                    style: style
                });
            }
        }
    ]);
    return MondayMarkupLanguageComponent;
}(react.PureComponent);
MondayMarkupLanguageComponent.defaultProps = {
    tagName: "div"
};
/* harmony default export */ var monday_markup_language_component = ((0,generic_config_context/* withGenericConfig */.P)(MondayMarkupLanguageComponent));


/***/ }),

/***/ 82305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ picture_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./services/community/cloudinary-service.js
var cloudinary_service = __webpack_require__(40927);
// EXTERNAL MODULE: ./services/dom-utils-service.js
var dom_utils_service = __webpack_require__(44566);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/visibility-sensor.js
var visibility_sensor = __webpack_require__(51529);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
;// CONCATENATED MODULE: ./constants/lazy-load-images.js
var PICTURE_LAZY_CLASS = "picture-lazy";
var PICTURE_LAZY_ATTRIBUTE = "data-source";

;// CONCATENATED MODULE: ./client/services/images-lazy-loading/images-lazy-loading.js

var lazyLoad = function(targetImage) {
    var io = new IntersectionObserver(function(imageEntries, observer) {
        imageEntries.forEach(function(entry) {
            if (entry.isIntersecting) {
                var img = entry.target;
                removeLazyLoadProperty(img);
                observer.disconnect();
            }
        });
    });
    io.observe(targetImage);
};
var removeLazyLoadProperty = function(img) {
    var src = img.getAttribute(PICTURE_LAZY_ATTRIBUTE);
    if (src) {
        img.setAttribute("src", src);
        img.classList.remove(PICTURE_LAZY_CLASS);
        img.removeAttribute(PICTURE_LAZY_ATTRIBUTE);
    }
};

// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./server/services/files-service/files-service.js
var files_service = __webpack_require__(14688);
// EXTERNAL MODULE: ./services/utils-service.js
var utils_service = __webpack_require__(20618);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/picture/picture-component.scss.js

var StyledPictureComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("picture", {
    target: "e1ujfqv60"
})("&.blur-image img{filter:blur(10px);}.picture-lazy{opacity:0;}");

;// CONCATENATED MODULE: ./components/core/picture/picture-component.js

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}














var PictureComponent = function(props) {
    var ref = (0,react.useState)(false), useLazyLoad = ref[0], setUseLazyLoad = ref[1];
    var _image = (0,react.useRef)(null);
    var shouldUseLazyLoad = props.shouldUseLazyLoad, mobile = props.mobile, imagesLazyLoad = props.imagesLazyLoad, src = props.src, alt = props.alt, shouldTrackMouseEvents = props.shouldTrackMouseEvents, className = props.className, pictureClass = props.pictureClass, specificImageStyle = props.specificImageStyle, assetQuality = props.assetQuality, isDecorative = props.isDecorative, extraCloudinaryTransformations = props.extraCloudinaryTransformations, isPreview = props.isPreview, skipCloudinaryConversion = props.skipCloudinaryConversion, pictureComponentHeight = props.pictureComponentHeight, onImageLoad = props.onImageLoad;
    (0,react.useEffect)(function() {
        lazyLoadImageIfNeeded();
        // This is to make sure picturefill is loaded only on the client as it breaks when loaded on the server
        var picturefill = __webpack_require__(47229);
        picturefill();
    }, []);
    (0,react.useEffect)(function() {
        lazyLoadImageIfNeeded();
    }, [
        src
    ]);
    var lazyLoadImageIfNeeded = function() {
        var current = _image.current;
        if (validateLazyLoadImages()) lazyLoad(current);
        else removeLazyLoadProperty(current);
    };
    var isImageCompleted = function(img) {
        return (0,dom_utils_service.isImageLoaded)(_image.current);
    };
    var renderSource = function(src, media) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
            srcSet: src,
            media: media
        });
    };
    var addLowResTransformations = function(cloudinaryTransformations) {
        return _object_spread_props(_object_spread({}, cloudinaryTransformations), {
            quality: cloudinary_service.LOW_RES_IMAGE_QUALITY_LEVEL,
            blur: cloudinary_service.IMAGE_DEFAULT_BLUR
        });
    };
    var addFakeRandomDefaultImageKeyForBrowserCacheBusting = function(cloudinaryTransformations) {
        var randInt = Math.ceil(Math.random() * 1000);
        return _object_spread_props(_object_spread({}, cloudinaryTransformations), {
            defaultImage: randInt
        });
    };
    var getCloudinaryTransformations = function() {
        var cloudinaryTransformations = (0,cloudinary_service.extractCloudinaryTransformations)(_object_spread({}, specificImageStyle, extraCloudinaryTransformations));
        if (isLowResImage()) {
            cloudinaryTransformations = addLowResTransformations(cloudinaryTransformations);
        }
        if (isPreview) {
            // for image preview we add a non existing default image key just to clear browser cache for uploading image with same name problem
            cloudinaryTransformations = addFakeRandomDefaultImageKeyForBrowserCacheBusting(cloudinaryTransformations);
        }
        return cloudinaryTransformations;
    };
    var getMobileImageSource = function(cloudinaryTransformations) {
        if (!mobile) return null;
        if ((0,cloudinary_service.isCloudinaryUrl)(mobile) || skipCloudinaryConversion) return mobile;
        return (0,cloudinary_service.generateCloudinaryImageUrl)(mobile, cloudinaryTransformations);
    };
    var getImageNameFromSrc = function(imgSrc) {
        if (!imgSrc) return "";
        try {
            var lastSeparator = imgSrc.lastIndexOf("/");
            var fileName = imgSrc.substr(lastSeparator + 1);
            var fileNameWithoutExtension = (0,files_service.removeFileExtension)(fileName);
            // our S3 image uploads code adds UUID to files - if this is the case we remove it
            if (fileName.length > utils_service.UUID_LENGTH && (0,utils_service.isUUID)(fileName.substring(0, utils_service.UUID_LENGTH))) {
                fileNameWithoutExtension = fileNameWithoutExtension.substring(utils_service.UUID_LENGTH);
            }
            return fileNameWithoutExtension.replace(/-|_/g, " ").trim(); // replace all - and _ with a space
        } catch (error) {
            console.error("Error generating alt text for imgSrc: ".concat(imgSrc, ":"), error);
            return imgSrc;
        }
    };
    var onVisibilityChange = function(visible, data) {
        if (visible && useLazyLoad) {
            setUseLazyLoad(false);
        }
    };
    // Rendering low res image if needed when using lazy load
    var isLowResImage = function() {
        return useLazyLoad;
    };
    var validateLazyLoadImages = function() {
        if (!window) return false;
        if (!("IntersectionObserver" in window)) return false;
        return shouldUseLazyLoad;
    };
    var onMouseEnter = function() {
        if (!shouldTrackMouseEvents) return;
        BigBrain("track", bigbrain_event_types.MOUSE_ENTER_IMAGE_ELEMENT, {
            placement: src,
            kind: alt
        });
    };
    var onClick = function() {
        if (!shouldTrackMouseEvents) return;
        BigBrain("track", bigbrain_event_types.CLICK_IMAGE_ELEMENT, {
            placement: src,
            kind: alt
        });
    };
    var renderPicture = function() {
        var cloudinaryTransformations = getCloudinaryTransformations();
        var cloudinaryUrl = (0,cloudinary_service.isCloudinaryUrl)(src) || skipCloudinaryConversion ? src : (0,cloudinary_service.generateCloudinaryImageUrl)(src, cloudinaryTransformations, {
            assetQuality: assetQuality
        });
        var mobileSrc = getMobileImageSource(cloudinaryTransformations);
        var imageAlt = isDecorative ? "" : alt || getImageNameFromSrc(src);
        var srcAttr = shouldUseLazyLoad ? PICTURE_LAZY_ATTRIBUTE : "src";
        var _obj;
        var imgAttrs = (_obj = {
            alt: imageAlt,
            ref: _image,
            className: classnames_default()(className, (0,_define_property/* default */.Z)({}, PICTURE_LAZY_CLASS, shouldUseLazyLoad))
        }, (0,_define_property/* default */.Z)(_obj, srcAttr, cloudinaryUrl), (0,_define_property/* default */.Z)(_obj, "style", specificImageStyle), (0,_define_property/* default */.Z)(_obj, "onLoad", onImageLoad || null), _obj);
        var topicImageInlineStyle = pictureComponentHeight ? {
            display: "flex",
            height: pictureComponentHeight,
            width: "100%"
        } : {};
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPictureComponent, {
            className: classnames_default()("picture-component", pictureClass, {
                "blur-image": isLowResImage() && !isImageCompleted()
            }),
            style: topicImageInlineStyle,
            children: [
                mobileSrc && renderSource(mobileSrc, vp_sizes/* MOBILE_QUERY */.lF),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", _object_spread_props(_object_spread({}, imgAttrs), {
                    onMouseEnter: onMouseEnter,
                    onClick: onClick
                }))
            ]
        });
    };
    if (imagesLazyLoad) {
        // when using lazy load - images will remain low res until visible in viewport
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
            offset: {
                top: 200
            },
            partialVisibility: true,
            onChange: onVisibilityChange,
            active: true,
            scrollCheck: true,
            children: renderPicture()
        });
    }
    return renderPicture();
};
/* harmony default export */ var picture_component = ((0,generic_config_context/* withGenericConfig */.P)(PictureComponent));
PictureComponent.defaultProps = {
    className: "",
    src: "",
    mobile: null,
    alt: "",
    pictureClass: "",
    specificImageStyle: {},
    screenRatios: {},
    imagesLazyLoad: false,
    shouldUseLazyLoad: false,
    shouldTrackMouseEvents: false,
    isDecorative: false,
    skipCloudinaryConversion: false
};


/***/ }),

/***/ 2522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ getLocalizedNumberOfPayingTeams; }
/* harmony export */ });
var NUMBER_OF_PAYING_TEAMS = 225000;
var getLocalizedNumberOfPayingTeams = function(localeId) {
    return NUMBER_OF_PAYING_TEAMS.toLocaleString(localeId || "en");
};


/***/ })

}]);